import { PhoneDto } from '@app/data/dtos/ptrab/shared/phone.dto';
import { PhonesDto } from '@app/data/dtos/ptrab/shared/phones.dto';
import { TwoFactorCodeDto, TwoFactorDto } from '@app/data/dtos/ptrab/two-factor/two-factor.dto';
import { ValidateCodeDto } from '@app/data/dtos/ptrab/two-factor/validate-code.dto';
import { Phone } from '@app/entities/interfaces/ptrab/shared/phone.interface';
import { Phones } from '@app/entities/models/ptrab/shared/phone.model';
import { TwoFactor, TwoFactorCode } from '@app/entities/models/ptrab/two-factor/two-factor.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapPhones: MapFromFn<PhonesDto, Phones> = (value) =>
  Builder.forModel(Phones)
    .phones((value?.phones || []).map(mapPhone))
    .message(value?.message)
    .build();

export const mapPhone: MapFromFn<PhoneDto, Phone> = (value) =>
  Builder.forModel(Phone)
    .description(value?.description)
    .type(value?.type)
    .phone(value?.phone)
    .id(value?.id)
    .editable(value?.editable)
    .sms(value?.sms)
    .build();

export const mapvalidateCode: MapFromFn<ValidateCodeDto, string> = (value) => value?.validation_hash;

export const mapTwoFactor: MapFromFn<TwoFactorDto, TwoFactor> = (value) =>
  Builder.forModel(TwoFactor).blockingTime(value?.blocking_time).code(mapTwoCode(value?.code)).build();

export const mapTwoCode: MapFromFn<TwoFactorCodeDto, TwoFactorCode> = (value) =>
  Builder.forModel(TwoFactorCode).code(value?.code).timestamp(value?.timestamp).triesCount(value?.tries_count).build();
